import { BaseOptionModel } from '@/models'
import { Flow } from '@paybis/frontend-common-lib/src/types/exchangeForm/exchange-form';

export const enum Promo {
  ZERO_COMMISSION = 'zeroCommission',
}

export const enum WalletTypes {
  PAYBIS = 'paybisWallet',
  EXTERNAL = 'externalWallet',
}

export interface State {
  selected: BaseOptionModel;
  flow: Flow;
  amount: string;
  equivalentAmount: string;
  showDropDown: boolean;
  error: string | null;
}
